"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(e, t, r, n, o, a, c) {
  try {
    var u = e[a](c),
      i = u.value;
  } catch (e) {
    return void r(e);
  }
  u.done ? t(i) : Promise.resolve(i).then(n, o);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (n, o) {
      var a = e.apply(t, r);
      function c(e) {
        asyncGeneratorStep(a, n, o, c, u, "next", e);
      }
      function u(e) {
        asyncGeneratorStep(a, n, o, c, u, "throw", e);
      }
      c(void 0);
    });
  };
}
var axios = require("axios"),
  ESTIMATOR_WHATIFS_API1_LAMBDA = "dwellingcost5-Lambda-SCOMW3US0YHS",
  ESTIMATOR_WHATIFS_API2_LAMBDA = "WhatIfScenarioLambdaV2",
  CLASS_NAME = "HomeScore:";
module.exports = {
  getHomeScores: function () {
    var e = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
      var r;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return "https://api2.getmybubble.io", r = "".concat("https://api2.getmybubble.io", "/fetch1?fun=HomeScore&version=v1&dget1=").concat(t), e.abrupt("return", axios.get(r).then(function (e) {
              return console.log(JSON.parse(e.data.output)), e;
            }).catch(function (e) {
              return e;
            }));
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }()
};